import { QUERY_KEY } from '@/const/key-stores';
import { useQState } from '@/hooks/useQState';

export const useErrorText = () => {
  const [errorText, setErrorText] = useQState<string | undefined>(QUERY_KEY.errorText);
  return { errorText, setErrorText };
};
